import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 1
const slug = 'indoor-and-outdoor-lighting-upgrades-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Indoor & Outdoor Lighting Upgrades Sydney | ${BUSINESS_NAME}`,
        description: "Brighten up your home or business with modern lighting solutions, including garden, security, and feature lighting.",
        keywords: "indoor lighting Sydney, outdoor lighting Sydney, garden lighting installation, security lighting solutions, feature lighting design, energy-efficient lighting, LED lighting upgrades, commercial lighting services, residential lighting solutions, landscape lighting Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Indoor & Outdoor Lighting Upgrades',
    description: 'Brighten up your home or business with modern lighting solutions, including garden, security, and feature lighting.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
